let animation1 = document.querySelectorAll(".animation1");
let animation2 = document.querySelectorAll(".animation2");

/* Scroll */
let btnScroll = document.querySelector(".fullBanner-sabores__btn button");
let carrosselBrands = document.querySelector(".carrosselBrands");

btnScroll.addEventListener("click", function (event) {
  event.preventDefault();

  const itemPosition = carrosselBrands.offsetTop; // Obtém a posição superior do elemento em relação ao documento
  const finalPosition = itemPosition - 100; // Subtrai 100 pixels para obter uma posição final deslocada

  window.scrollTo({
    top: finalPosition,
    behavior: "smooth",
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // Array das classes das imagens
const imageClasses = [
  ".animationSabores2-0",
  ".animationSabores2-1",
  ".animationSabores2-3",
  ".animationSabores2-4",
  ".animationSabores2-5"
];

// Inicializa a variável para rastrear a imagem visível
let currentIndex = 0;

// Função para alternar a visibilidade das imagens
function showNextImage() {
  // Esconde todas as imagens
  imageClasses.forEach((cls, index) => {
      const image = document.querySelector(cls);
      if (image) {
          image.style.opacity = "0";
          image.style.transition = "opacity 1s"; // Suaviza a transição
      }
  });

  // Mostra a próxima imagem
  const nextImage = document.querySelector(imageClasses[currentIndex]);
  if (nextImage) {
      nextImage.style.opacity = "1";
  }

  // Atualiza o índice para a próxima imagem
  currentIndex = (currentIndex + 1) % imageClasses.length;
}

// Inicializa o ciclo da animação
setInterval(showNextImage, 3000);

// Exibe a primeira imagem ao carregar a página
showNextImage();

});
